import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
var _excluded = ["spacing", "p"],
  _excluded2 = ["p", "spacing", "breakpoints", "axis", "contentWidth", "fillParent", "height", "children"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import React from 'react';
import styled, { css } from 'styled-components';
import { getLength, getPropNamesFromPropDefinition, getPropFilter, createStyleFunction } from 'utils/ui';
import { paddingProps, paddingPropsDef } from 'styles/styleProps';
var responsiveWidthProp = createStyleFunction([{
  styleProp: 'width',
  getValue: getLength
}]);
var wrapperPropsToFilter = ['fillParent', 'width', 'height', 'spacing', 'axis'];
var paddingPropsToFilter = getPropNamesFromPropDefinition(paddingPropsDef);
var shouldForwardProp = getPropFilter([].concat(wrapperPropsToFilter, _toConsumableArray(paddingPropsToFilter)));

/**
 * Define the maximum width for the centred content.
 * Supports responsive values when used with the breakpoints prop.
 */

var Wrapper = styled.div.withConfig({
  shouldForwardProp: shouldForwardProp
}).withConfig({
  displayName: "CenterContent__Wrapper",
  componentId: "sc-1ts6to3-0"
})(["display:flex;flex:1 1 auto;", " ", " ", " box-sizing:border-box;"], function (p) {
  return p.height && css(["min-height:", ";"], getLength(p.height));
}, function (_ref) {
  var spacing = _ref.spacing,
    p = _ref.p,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return paddingProps(_objectSpread({
    p: spacing || p
  }, otherProps));
}, function (p) {
  return p.fillParent && css(["position:absolute;top:0;left:0;width:100%;min-height:100%;"]);
});
var Content = styled('div').withConfig({
  shouldForwardProp: shouldForwardProp
}).withConfig({
  displayName: "CenterContent__Content",
  componentId: "sc-1ts6to3-1"
})(["", " max-width:100%;", " ", " ", ""], responsiveWidthProp, function (p) {
  return (!p.axis || p.axis === 'both') && 'margin: auto;';
}, function (p) {
  return p.axis === 'x' && 'margin-inline: auto;';
}, function (p) {
  return p.axis === 'y' && 'margin-block: auto;';
});
function CenterContent(_ref2) {
  var p = _ref2.p,
    spacing = _ref2.spacing,
    _ref2$breakpoints = _ref2.breakpoints,
    breakpoints = _ref2$breakpoints === void 0 ? ['xxxs', 'xxs', 'xs'] : _ref2$breakpoints,
    _ref2$axis = _ref2.axis,
    axis = _ref2$axis === void 0 ? 'both' : _ref2$axis,
    contentWidth = _ref2.contentWidth,
    fillParent = _ref2.fillParent,
    height = _ref2.height,
    children = _ref2.children,
    otherProps = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/React.createElement(Wrapper, _extends({
    fillParent: fillParent,
    height: height,
    p: p || spacing || [undefined, 'xxs', 'xs', 'm'],
    breakpoints: breakpoints
  }, otherProps), /*#__PURE__*/React.createElement(Content, {
    width: contentWidth,
    axis: axis,
    breakpoints: breakpoints
  }, children));
}
export default CenterContent;